import {
	currentUserMeetsUserLevel,
	UserLevel,
} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {currentCartHasMultipleItems} from './currentCartHasMultipleItems';
import {
	currentUserHasAccess,
	PermissionName,
} from '@netx/core-permissions-next/enablers';

export const canManageCurrentCartRelationships = (): boolean => {
	if (!currentCartHasMultipleItems()) return false;
	if (!currentUserMeetsUserLevel(UserLevel.PRODUCER)) return false;
	return currentUserHasAccess(PermissionName.MANAGE_RELATIONSHIPS);
};
